import { UserWrite } from "src/api/client-api/user/useCreateUser";

export type UserModalPayloadFormData = {
    id?: number;
    firstname: string;
    lastname: string;
    email: string;
    phone?: string;
    roles?: string[];
    platformAdmin?: boolean;
    jsonAttributes?: Record<string, any>;
};

type BuildUserModalPayloadOptions = {
    isEditing: boolean;
    hasUserJsonAttributes: boolean;
    includeRolesOnEdit?: boolean;
    platformRoleOptions?: string[];
};

export const buildUserModalPayload = (
    formData: UserModalPayloadFormData,
    options: BuildUserModalPayloadOptions,
): UserWrite => {
    const { isEditing, hasUserJsonAttributes, includeRolesOnEdit = false, platformRoleOptions } = options;
    const allowedPlatformRoles = platformRoleOptions ? new Set(platformRoleOptions) : null;
    const submittedRoles = (formData.roles || []).filter(
        (role) => role !== "ROLE_ADMIN" && (allowedPlatformRoles === null || allowedPlatformRoles.has(role)),
    );
    const roles =
        formData.platformAdmin === true ? Array.from(new Set([...submittedRoles, "ROLE_ADMIN"])) : submittedRoles;
    const userData: UserWrite = {
        firstname: formData.firstname.trim(),
        lastname: formData.lastname.trim(),
        email: formData.email.trim(),
        phone: formData.phone?.trim() || undefined,
        ...(isEditing ? { id: formData.id } : { plainPassword: "temporary123!" }),
    };

    if (!isEditing) {
        userData.roles = roles;
    } else if (includeRolesOnEdit) {
        userData.roles = roles;
    }

    if (hasUserJsonAttributes) {
        userData.jsonAttributes =
            formData.jsonAttributes ?
                Object.fromEntries(
                    Object.entries(formData.jsonAttributes).filter(
                        ([_, value]) => value !== "" && value !== null && value !== undefined,
                    ),
                )
            :   {};
    }

    return userData;
};
